namespace Solovis.Reports.Parameters {

    export class ContactParameterControl extends Solovis.UI.BaseControl {

        private _portalServices: Solovis.Portal.IPortalServices;

        private initialParameterValue;
        private currentContact;

        private selectedContactLabel;
        private selectContactLink;

        private _selectionDialog: Solovis.UI.Dialog;

        constructor(options) {
            super(options);

            this._portalServices = options.portalServices;

            this.initialParameterValue = (typeof options.initialValue != "undefined") ? options.initialValue : null;
            this.currentContact = this.initialParameterValue;
        }


        public static preload(newValue, callback, portalServices: Solovis.Portal.IPortalServices) {
            if (newValue && newValue.contactId) {
                portalServices.rpc().invoke(
                    "~/Selectors/ContactSelector/GetContactData", { contactId: newValue.contactId },
                    function (response, success) {
                        if (success) {
                            var contactData = response.result;
                            callback(contactData, true);
                        }
                        else {
                            callback(null, false);
                        }
                    });
            }
            else if (newValue && newValue.resourceId) {
                portalServices.rpc().invoke(
                    "~/Selectors/ContactSelector/GetContactData", { resourceId: newValue.resourceId },
                    function (response, success) {
                        if (success) {
                            var contactData = response.result;
                            callback(contactData, true);
                        }
                        else {
                            callback(null, false);
                        }
                    });
            }
            else {
                callback(null, true);
            }
        }

        public static serializeParameterValue(value): any {
            if (value) {
                if (value.contactId) {
                    return { contactId: value.contactId };
                }
                else if (value.resourceId) {
                    return { resourceId: value.resourceId };
                }
                else {
                    return null;
                }
            }

            return null;
        }
        

        public doRender() {
            var self = this;

            this.selectedContactLabel = $("<a>").appendTo(this.container)
                .click(function (e) {
                    if (self.currentContact && self.currentContact.contactId) {
                        Solovis.UI.PopupLinkPanel.showLinks({
                            offset: { left: e.pageX, top: e.pageY },
                            links: self._portalServices.reportLinker().getContactLinks(self.currentContact.contactId)
                        });
                    }
                });
            this.selectContactLink = $("<a>").html("<span class='fa fa-pencil'></span>").appendTo(this.container);

            this.selectContactLink.click(function () {
                self._toggleSelectorDialog(function (contact) {
                    self._setCurrentContactData(contact);
                    self.notifyParameterValueChanged();
                });
            });

            // Set initial parameter value text.
            if (this.currentContact) {
                this._setCurrentContactData(this.currentContact);
            }
        }

        public _setCurrentContactData(contactData) {
            this.currentContact = contactData;
            if (this.currentContact) {
                this.selectedContactLabel.text(this.currentContact.label + " ");
            }
            else {
                this.selectedContactLabel.text("");
            }
        }

        public setParameterValue(newValue) {
            this._setCurrentContactData(newValue);
        }

        public getParameterValue() {
            if (this.state < Solovis.UI.BaseControl.ControlState.afterInit) {
                return this.initialParameterValue ? this.initialParameterValue : null;
            }
            else if (this.currentContact) {
                return Solovis.deepCopy(this.currentContact);
            }
            else {
                return null;
            }
        }

        public notifyParameterValueChanged() {
            $(this).trigger("parameterValueChanged");
        }


        public _toggleSelectorDialog(selectionCallback) {
            var self = this;

            if (this._selectionDialog) {
                // We already have the selection dialog open, so close it.
                this._selectionDialog.close();
                this._selectionDialog = null;
                return;
            }


            var selectorControlHostDiv = $("<div>");
            var selectorControlHost = new Solovis.UI.ControlHost({ container: selectorControlHostDiv });
            var selectorControl = new Solovis.InvDataSelectors.ContactSelectorControl({
                controlHost: selectorControlHostDiv,
                portalServices: this._portalServices,
                selectionCallback: function (contact) {
                    selectionCallback(contact);
                    self._selectionDialog.close();
                },
                cancelCallback: function () {
                    self._selectionDialog.close();
                }
            });
            selectorControlHost.setCurrentControl(selectorControl);


            // Determine dialog position.        
            var linkOffset = $(this.selectedContactLabel).offset();
            var linkHeight = $(this.selectContactLink).outerHeight();
            var dialogPosition = {
                left: linkOffset.left,
                top: linkOffset.top + linkHeight + 5
            };

            var adjustedPosition = Solovis.UI.Dialog.autoAdjustSizeAndPosToViewport(dialogPosition, { width: 350, height: 150 });

            this._selectionDialog = new Solovis.UI.Dialog({
                container: selectorControlHostDiv,
                ownerDialog: Solovis.UI.Dialog.findContainingDialog(this.container),

                title: false,
                autoOpen: true,
                destroyOnClose: true,
                actions: ["Close"],
                noAnimation: true,
                position: adjustedPosition,

                buttons: [
                    {
                        label: "Clear",
                        click: function () {
                            selectionCallback(null);
                            self._selectionDialog.close();
                        }
                    },
                    {
                        label: "Cancel",
                        click: function () {
                            self._selectionDialog.close();
                        }
                    }
                ],

                activate: function () {
                    (selectorControl as any).focus();
                },

                deactivate: function () {
                    self._selectionDialog = null;
                }
            });
        };

    }

}
